import Swiper from "swiper/bundle";

window.addEventListener("DOMContentLoaded", () => {
	const logoSliders = document.querySelectorAll(".partners__logos");

	logoSliders.forEach((s) => {
		const speed = s.dataset.speed * 1000;
		const slidesCount = s.querySelectorAll(".swiper-slide").length;

        if (slidesCount < 2) {
			
			const containerDiv = document.createElement("div");
            containerDiv.classList.add("container");
            s.parentNode.insertBefore(containerDiv, s);
            containerDiv.appendChild(s);

		} else {
			new Swiper(".partners__logos", {
				slidesPerView: 2,
				spaceBetween: 74,
				loop: true,
				autoplay: {
					delay: 1,
					disableOnInteraction: true,
				},
				speed: speed,
				freeMode: true,
				breakpoints: {
					768: {
						slidesPerView: 2.5,
						spaceBetween: 74,
					},
					1024: {
						slidesPerView: 3.5,
						spaceBetween: 120,
					},
				},
			});
		}
	});
});
